import { priceFormatter } from '@2wunder/klarx-tool'
import { MemberProps } from 'app/components/Core/convention'
import { RecordType } from 'app/constants/GlobalTypes'
import useTranslation from 'app/lib/hooks/useTranslation'
import { FC } from 'react'

type Props = {
  attribute?: 'total' | 'displayDiscountedUnitPrice'
}

const PriceCell: FC<MemberProps<ISubItem, Props>> = ({ member, props }) => {
  const { freeAttachment } = member || {}
  const { attribute = 'displayDiscountedUnitPrice' } = props || {}
  const { tAttribute } = useTranslation({
    recordType: RecordType.line_item
  })
  const value = member[attribute]
  if (freeAttachment) return tAttribute({ id: 'inclusive' })

  return priceFormatter(value)
}

export default PriceCell
